import { getSiteOrigin } from "./urls";
import { buildBreadcrumbList, BreadcrumbEntry } from "./breadcrumbs";
import { buildSearchAction } from "./searchAction";

/**
 * Builds SEO-related structured data (JSON-LD) for breadcrumbs and search actions.
 */
export function buildSeoLinkedData(args: {
    vm: { seo?: { breadCrumbs?: Record<string, string>; title?: string }, searchPageUrl?: string };
    origin?: string;
    currentPath?: string;
}) {
    // Determine the site origin (use provided or derive from environment)
    const origin = args.origin ?? getSiteOrigin();

    // Determine the current path (default to browser's pathname, fallback to "/")
    const currentPath =
        args.currentPath ?? (typeof window !== "undefined" ? window.location.pathname : "/");

    // Default breadcrumb (always include homepage)
    const defaultCrumbs: Record<string, string> = { "Cadac Group": "/" };

    // User-defined breadcrumbs (optional)
    const userCrumbs = args.vm.seo?.breadCrumbs || {};

    // Current page name (fallback to generic if missing)
    const currentName = args.vm.seo?.title || "Current Page";

    // Combine default + user breadcrumbs
    const combined: BreadcrumbEntry[] = [
        ...Object.entries(defaultCrumbs),
        ...Object.entries(userCrumbs),
    ];

    // If no user breadcrumbs provided, append the current page as the last crumb
    if (!args.vm.seo?.breadCrumbs || Object.keys(userCrumbs).length === 0) {
        combined.push([currentName, currentPath]);
    }

    // Generate schema.org BreadcrumbList
    const breadCrumbsLinkedData = buildBreadcrumbList(combined, origin);

    // Generate schema.org WebSite with SearchAction
    const searchLinkedData = buildSearchAction({
        origin,
        siteName: "Cadac Group | Enabling digital. | Autodesk Platinum Partner",
        searchPath: args.vm.searchPageUrl || "/search",
    });

    // Return both objects and JSON strings for embedding into <script> tags
    return {
        breadCrumbsLinkedData,
        breadCrumbsLinkedDataJson: JSON.stringify(breadCrumbsLinkedData),
        searchLinkedData,
        searchLinkedDataJson: JSON.stringify(searchLinkedData),
    };
}